import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChartCardComponent } from '@ui';
import { RankingLinesIntensityTableComponent } from './ranking-lines-intensity.table';
import { ChartHeader } from '@charts';
import { TranslocoDirective } from '@jsverse/transloco';
import { CapacityRankingLine } from '@data';

@Component({
  selector: 'ui-ranking-lines-intensity',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChartCardComponent,
    ChartHeader,
    RankingLinesIntensityTableComponent,
    TranslocoDirective,
  ],
  template: `
    <div *transloco="let t">
      <ui-chart-card>
        <div class="flex flex-col gap-y-4 w-full">
          <chart-header
            [title]="t('CHARTS.PHASE_INTENSITY.TITLE')"
            [subtitle]="t('CHARTS.PHASE_INTENSITY.SUBTITLE')"
          />

          <ui-ranking-lines-intensity-table [data]="data()" />
        </div>
      </ui-chart-card>
    </div>
  `,
})
export class RankingLinesIntensityComponent {
  data = input<CapacityRankingLine[]>([]);
}
